(function () {
    'use strict';

    angular
        .module('franchiser.components')
        .controller('PeopleFranchiserPreRegisterController', PeopleFranchiserPreRegisterController)

    /** @ngInject */
    function PeopleFranchiserPreRegisterController( $q, CompanyService, PreRegistraterService, UtilHelper, NotifyHelper, LoadingHelper, sweetAlert) {
        const vm = this;

        let isTableSearch = false;
        let forcePaginationReset = false;
        let allCompanies = [];

        vm.isSearchDisabled = () => {
            if (vm.selectedCompany || (vm.selectedSearchField && vm.searchText))
                return false;

            return true;
        }

        vm.isClearDisabled = () => {
            if (isTableSearch)
                return false;

            if (vm.selectedCompany || vm.selectedSearchField || vm.searchText)
                return false;

            return true;
        }

        vm.doSearch = (event, isFromButton) => {
            if (!vm.isSearchDisabled() && (event && event.keyCode == 13) || isFromButton) {
                forcePaginationReset = true;
                vm.isLoading = true;

                vm.tableCallServer();
            }
        }

        vm.clearSearch = () => {
            vm.selectedCompany = null;
            vm.selectedSearchField = null;
            vm.searchText = null;
            vm.preRegisters = [];

            isTableSearch = false;
        }

        vm.tableCallServer = (tableState, stCtrl) => {
            if (!vm.stCtrl && stCtrl)
                vm.stCtrl = stCtrl;

            if (!tableState && vm.stCtrl) {
                vm.stCtrl.pipe();
                return;
            }

            vm.isLoading = true;

            if (forcePaginationReset) {
                tableState.pagination.start = 0;
                forcePaginationReset = false;
            }

            const pagination = tableState.pagination;
            const start = pagination.start || 0;
            const number = pagination.number || 10;

            getPreRegisters(start, number, tableState);
        }

        vm.deletePreRegister = preRegisterId => {
            sweetAlert.swal({
                title: 'Você tem certeza?',
                text: 'Não é possível desfazer essa ação!',
                type: 'warning',
                confirmButtonText: 'Sim, tenho certeza',
                showCancelButton: true,
                cancelButtonText: 'Não, cancelar',
                allowOutsideClick: false,
                allowEscapeKey: false
            }).then(response => {
                if (response.value) {
                    LoadingHelper.startLoading('.custom-table');

                    PreRegistraterService
                        .remove(preRegisterId)
                        .then(() => {
                            LoadingHelper.stopLoading('.custom-table');
                            vm.tableCallServer();
                            UtilHelper.successCallback('delete');
                        }, error => {
                            UtilHelper.errorCallback(error);
                            LoadingHelper.stopLoading('.custom-table');
                        });
                }
            });
        }

        vm.resendMail = preRegister => {
            sweetAlert.swal({
                title: 'Você tem certeza?',
                text: 'Um e-mail de aviso será disparado para a pessoa.',
                type: 'warning',
                confirmButtonText: 'Sim, tenho certeza',
                showCancelButton: true,
                cancelButtonText: 'Não, cancelar',
                allowOutsideClick: false,
                allowEscapeKey: false
            }).then(response => {
                if (response.value) {
                    LoadingHelper.startLoading('.custom-table');

                    PreRegistraterService
                        .resendMail(preRegister)
                        .then(() => {
                            LoadingHelper.stopLoading('.custom-table');
                            NotifyHelper.success('E-mail reenviado com sucesso!');
                        }, error => {
                            UtilHelper.errorCallback(error);
                            LoadingHelper.stopLoading('.custom-table');
                        });
                }
            });
        }

        vm.getCompanies = search => {
            if (!search) {
                vm.companies = [];
                return;
            }

            vm.companies = allCompanies.filter(company => filterCompany(company, search));
        }

        init();

        function getPreRegisters(skip, perPage, tableState) {
            let parameters = prepareParameters(skip, perPage, tableState);

            PreRegistraterService
                .getByParameters(parameters)
                .then(success => {
                    vm.preRegisters = success.Registers;
                    tableState.pagination.numberOfPages = success.NumberOfPages;

                    vm.isLoading = false;
                }, error => {
                    vm.preRegisters = null;
                    vm.isLoading = false;
                    UtilHelper.errorCallback(error);
                });
        }

        function getAllCompaniesResumed() {
            return CompanyService
                .getAllResumed()
                .then(success => {
                    allCompanies = success;
                }, error => {
                    UtilHelper.errorCallback(error);
                    LoadingHelper.stopLoading('.custom-filters');
                });
        }

        function filterCompany(company, search) {
            if (company.FantasyName == null)
                company.FantasyName = '';

            if (company.CorporateName == null)
                company.CorporateName = '';

            if (company.UniqueCode == null)
                company.UniqueCode = '';

            if (company.ExternalCode == null)
                company.ExternalCode = '';

            if (company.FantasyName.toLowerCase().includes(search.toLowerCase()) || company.CorporateName.toLowerCase().includes(search.toLowerCase()) || company.UniqueCode.toString().includes(search) || company.ExternalCode.toString().includes(search))
                return company;
        }

        function prepareParameters(skip, perPage, tableState) {
            let params = {
                Skip: skip,
                PerPage: perPage,
                OrderBy: 'Name',
                OrderDescending: false
            }

            if (vm.selectedCompany || (vm.selectedSearchField && vm.searchText))
                isTableSearch = true;

            if (vm.selectedCompany)
                params.CompanyId = vm.selectedCompany.Id;

            if (tableState && tableState.sort.predicate) {
                params.OrderBy = tableState.sort.predicate;
                params.OrderDescending = tableState.sort.reverse;
            }

            if (vm.selectedSearchField && vm.searchText)
                params[vm.selectedSearchField.Value] = vm.searchText;

            return params;
        }

        function init() {
            vm.selectedCompany;
            vm.selectedSearchField;
            vm.searchText;
            vm.isLoading = true;

            vm.searchFields = [{
                Value: 'Name',
                Description: 'Nome'
            }, {
                Value: 'Email',
                Description: 'E-mail'
            }];

            LoadingHelper.startLoading('.custom-filters');

            $q.all([getAllCompaniesResumed()])
                .then(() => {
                    LoadingHelper.stopLoading('.custom-filters');
                })
        }
    }
}());